import React, { useContext } from "react";
import Report from "views/Statistics/Report/Hourly/component";
import ActionsContext from "common/ActionsContext";
import { parsePoliciesFlows } from "../api";
import { safeStr, getBqnIdCmdPart } from "common/api";
import View from "common/View";
import Help from "./Help";


const doFlowsShareRetrieval = (hours = 24, type = "flow", mode, bqnId) =>
  ifCl.run(`show statistics policy ${safeStr(type)} speed lines ${hours * 12}${getBqnIdCmdPart(mode, bqnId)}`);

const retrieval = ({ hours, type, mode, bqnId }) =>
  doFlowsShareRetrieval(hours, type, mode, bqnId)
    .then(parsePoliciesFlows)
    .catch((error) => console.error(error) || error);

const enabled = {
  hours: true,
  directions: false,
  categories: false,
  target: false,
  output: false,
  filter: false,
};

const FlowsPerLPolicyHourly = () => {
  const actions = useContext(ActionsContext);
  return (
    <View title="Flows per policy over time" Help={Help}>
      <Report
        from="timeline"
        itemsFrom="policies"
        itemsValueFrom="flows"
        yAxisUnits="Flows"
        yAxisPrecision={0}
        provider={retrieval}
        actions={actions}
        enabled={enabled}
      />
    </View>
  );
};

export default FlowsPerLPolicyHourly;
